import { render, staticRenderFns } from "./change-status-by-sub-program.vue?vue&type=template&id=84fb5030&"
import script from "./change-status-by-sub-program.vue?vue&type=script&lang=js&"
export * from "./change-status-by-sub-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports